"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inWeightShare = exports.weightShareLabelDe = exports.CHART_DEFAULT_WEIGHT_SHARE = exports.CHART_WEIGHT_SHARE_KEYS = exports.CHART_WEIGHT_SHARES = exports.CHART_DATA_MODES = void 0;
exports.weightShares = weightShares;
// Dashboard switch "Fitnesswerte | Gewichtsklassifikation" (v7, Gerald
// 10/2026) and the combined weight shares of the map. In the
// Gewichtsklassifikation mode every view shows ALL weight classes together as
// one stacked 100 % bar (UG/NG/ÜG/AD/EA); a single class is never shown
// alone. See documentation/charts.md ("Fitnesswerte | Gewichtsklassifikation").
const weight_class_1 = require("./weight-class");
exports.CHART_DATA_MODES = ["fitness", "weight"];
exports.CHART_WEIGHT_SHARES = {
    OVERWEIGHT_OR_MORE: ["OVERWEIGHT", "OBESE", "EXTREME_OBESE"],
    OBESE_OR_MORE: ["OBESE", "EXTREME_OBESE"],
    UNDERWEIGHT: ["UNDERWEIGHT"],
};
exports.CHART_WEIGHT_SHARE_KEYS = Object.keys(exports.CHART_WEIGHT_SHARES);
exports.CHART_DEFAULT_WEIGHT_SHARE = "OVERWEIGHT_OR_MORE";
/** "Übergewicht + Adipositas + extreme Adipositas" (German, PDF). */
const weightShareLabelDe = (key) => exports.CHART_WEIGHT_SHARES[key].map((k) => weight_class_1.WEIGHT_CLASS_LABEL_DE[k]).join(" + ");
exports.weightShareLabelDe = weightShareLabelDe;
/** True when `weightClass` counts for the share `key`. */
const inWeightShare = (key, weightClass) => exports.CHART_WEIGHT_SHARES[key].includes(weightClass);
exports.inWeightShare = inWeightShare;
/** Exact shares (sum = 100 %) of a distribution, for stacked bars. */
function weightShares(d) {
    return Object.fromEntries(weight_class_1.WEIGHT_CLASS_KEYS.map((k) => [
        k,
        d.classified ? (d.counts[k] / d.classified) * 100 : 0,
    ]));
}
